<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

      <div class="row">
        
        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Solicitud Compras
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en compras</p>
            </div>
          </div>
        </div>

      
      </div>
      <div class="float-right">
        <button type="button" v-b-modal.modalFilters class="btn btn-primary">
          Filtrar
        </button>
      </div>
			<div class="d-inline mr-4">
				<button type="button" v-b-modal.requestPurchase class="btn btn-primary">
					Solicitar compra
				</button>
			</div>

      <div class="d-inline">
        <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
          CSV
        </button>
      </div> 
			<div class="table table-padded">
				

        <b-card mb-2>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
                
               :items="buys"
               :fields="fields"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
                @filtered="onFiltered" class="table table-padded"
          >

               <template slot="status" slot-scope="row">
                 <template v-if="row.item.status == 2">
                    Aprobada
                  </template>
                  <template v-else-if="row.item.status == 1">
                    Pendiente
                  </template>
                  <template v-else>
                    Rechazada
                  </template>
               </template>

               <template slot="createdAt" slot-scope="row">
                 {{row.item.createdAt.substr(0, 10)}}
               </template>

               <template slot="createdAtHour" slot-scope="row">
                 {{row.item.createdAt.substr(11, 5)}}
               </template>


               <template slot="buyAt" slot-scope="row">
                 {{row.item.buyAt.substr(0, 10)}}
               </template>
               
               <template slot="carrier" slot-scope="row">
                   <img :src="'/providers/'+row.item.Carrier.image" class="bank">
                </template>

                <template slot="description" slot-scope="row">
                   {{row.item.description}}
                </template>


               <template slot="amount" slot-scope="row">
                <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>
               </template>

   
 

                <template slot="action" slot-scope="row" >
                  <template v-if="row.item.observation != null">
                    <button v-on:click="showBuy(row.item)" type="button" class="actionBtnTable nobtn">
                    <i class="material-icons" style="color: #dab51b;">remove_red_eye</i>
                  </button>
                  </template>
                  
                </template> 
               

        </b-table>

        <b-row>
          <b-col md="12" class="my-1 float-right">
            <b-pagination :total-rows="buys.length" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>


      </b-card >



					<!--thead>
						<tr>
							<th>{{$t('table.status')}}</th>
              <th>{{$t('table.date')}}</th>
              <th>{{$t('table.hour')}}</th>
							<th>{{$t('table.carrier')}}</th>
							<th>{{$t('table.observation')}}</th>
							<th>{{$t('table.value')}}</th>
							<th>{{$t('table.action')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(buy, index) in buys" :key="index">
							<td>
                <template v-if="buy.status == 1">
                  Pendiente
                </template>
                <template v-if="buy.status == 2">
                  Aprobada
                </template>
                <template v-if="buy.status == 3">
                  Rechazada
                </template>
              </td>
              <td>{{buy.createdAt.substr(0, 10)}}</td>
              <td>{{buy.createdAt.substr(11, 5)}}</td>
							<td>
                <img :src="'/providers/'+buy.Carrier.image" class="bank">
              </td>
							<td>{{buy.description}}</td>
							<td>
								<h2 class="itemIndicator" :class="buy.type == 'add' ? 'low' : ''">${{money(buy.amount)}}</h2>
							</td>
							<td>

                <button v-on:click="showBuy(buy)" type="button" class="actionBtnTable nobtn">
                  <i class="material-icons" style="color: #dab51b;">remove_red_eye</i>
                </button>

                <!button v-b-modal.payModal type="button" class="actionBtnTable nobtn"><i class="material-icons" style="color: #dab51b;">attach_money</i></button> -->
							<!--/td>

						</tr>
					</tbody-->
				

				

			</div>

		</div>
			
		<app-footer/>

	<b-modal id="payModal" title="Abonar">
		<div class="box-modal"> 

			<form>
				<div class="form-group">
			
					<label class='control-label'>Valor a Abonar</label>		
					<input type="text"  class="form-control" v-model='formPay.payAmount'>		
				</div>
			</form>
	      	

      	</div>
	</b-modal>



  <b-modal id="showBuy" hide-footer ref="showBuy" centered class='box-modal' title = "Observación del Administrador">
 
      <div>
        {{current.observation}}
      </div>   
  
	 
  </b-modal>


  <b-modal id="requestPurchase" ref="requestPurchase" centered   class='box-modal' title = "Solicitud de Compra" @ok="requestBuy()" >
      	
  	<div class="box-modal"> 

      	<div class="form-group">
		
    			<label class='control-label'>Fecha de la compra</label>		
    			<input type="date"  class="form-control" v-model="formRequestBuy.buyAt">		
    		</div>

    		<div class="form-group">
    		
    			<label class='control-label'>Operador</label>
    		    <select class="form-control" v-model="formRequestBuy.carrierId">
    		    	<option v-for="(carrier, index) in carriers" :key="index" :value="carrier.id">
    		    		{{carrier.name}}
    		    	</option>
    		    </select>	
    		</div>
			
    		<div class="form-group">
    			<label class='control-label'>Valor de la compra</label>
          <money  v-model="formRequestBuy.amount" class="form-control"></money>
    		</div>

        <div class="form-group">
    
          <label class='control-label'>Observación</label>   
          <textarea  class="form-control" v-model="formRequestBuy.description">
          </textarea>
        </div>
			 	
    </div>    
        
  </b-modal>

  <b-modal id="modalFilters" ref="modalFilters" title="Filtrar" hide-footer>
    <form v-on:submit.prevent="read">

      <div class="form-group">
        <label>Fecha Inicial</label>
        <input type="date" class="form-control" v-model="filters.dateStart">
      </div>

      <div class="form-group">
        <label>Fecha Final</label>
        <input type="date" class="form-control" v-model="filters.dateEnd">
      </div>


      <div class="form-group">
          
        <label class='control-label'>Operador</label>
          <select class="form-control" v-model="filters.carrierId">
            <option v-for="(carrier, index) in carriers" :key="index" :value="carrier.id">
              {{carrier.name}}
            </option>
          </select> 
      </div>

      <div class="form-group">
          <label class='control-label'>Estado</label>
          <select class="form-control" v-model="filters.status">
            <option value="1" >Pendiente</option>
            <option value="2" >Aprobada</option>
            <option value="0" >Rechazada</option>
          </select> 
      </div>

      <div class="d-inline mr-4">
            <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
            </button>
      </div>
      <div class="d-inline">
        <button type="submit" class="btn btn-primary">Filtrar</button>
      </div>
    </form>

  

  </b-modal>




	</div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_CARRIERS,
  REQUEST_BUY,
  FETCH_BUYS,
  PAY_DEBT,
  FETCH_BANKS
} from "@/store/actions.type";
import { required } from "vuelidate/lib/validators";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      formRequestBuy: {},

      formPay: {
        payAmount: 0
      },
      current: {},
      filters: {
        dateStart: "",
        dateEnd: "",
        bankId: "",
        carrierId: ""
      },
      data: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "status", label: "Estado", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "carrier", label: "Operador", sorteable: true },
        { key: "buyAt", label: "Fecha Compra", sorteable: true },
        { key: "description", label: "Descripción", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ]
    };
  },

  validations: {
    requestBuy: {
      dateStart: {
        required
      },
      carrierId: {
        required
      },
      valueBuy: {
        required,
        min: 4
      }
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_CARRIERS);
    this.$store.dispatch(FETCH_BANKS);
    this.read();
  },
  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_BUYS, this.filters);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },
    requestBuy() {
      this.$store
        .dispatch(REQUEST_BUY, this.formRequestBuy)
        .then(result => {
          this.formRequestBuy = {};
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    payDebt() {
      this.$store
        .dispatch(PAY_DEBT, this.form)
        .then(result => {
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    showBuy(buy) {
      this.current = buy;
      this.$refs.showBuy.show();
    },

    generateCVS() {
      var total = 0;
      var rows = this.buys.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;

        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          item.Carrier.name,
          item.description,
          item.bankName,
          "$" + item.amount
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Operador",
          "Observacion",
          "Banco",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Compras.csv";
      hiddenElement.click();
    }
  },
  computed: {
    ...mapGetters(["transactions", "carriers", "buys", "banks"]),
    total: function() {
      var total = 0;
      this.buys.map(row => (total += row.amount));
      return total;
    }
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .table-head {
    background: #dab51b;
    border: none;
    color: white;
  }
}
</style>
